"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const aws_react_1 = require("@mit/aws-react");
const app_config_global_1 = __importDefault(require("../app-config-global"));
class AuthService {
    constructor() {
        this.getToken = () => __awaiter(this, void 0, void 0, function* () {
            const authorizationToken = yield new aws_react_1.AuthProvider(Object.assign(app_config_global_1.default)).getToken();
            return authorizationToken;
        });
        this.logout = () => __awaiter(this, void 0, void 0, function* () {
            console.log('AuthService.logout()');
            yield new aws_react_1.AuthProvider(Object.assign(app_config_global_1.default)).signOut();
        });
    }
}
const authService = new AuthService();
exports.default = authService;
